import {Fragment} from 'react';
import ICON_APPLE_LIGHT from '../../../public/static/auth/login-ico-sns-apple-light.svg';
import ICON_APPLE from '../../../public/static/auth/login-ico-sns-apple.svg';
import ICON_FACEBOOK from '../../../public/static/auth/login-ico-sns-fb.svg';
import ICON_GOOGLE_LIGHT from '../../../public/static/auth/login-ico-sns-google-light.svg';
import ICON_GOOGLE from '../../../public/static/auth/login-ico-sns-google.svg';
import ICON_LINE from '../../../public/static/auth/login-ico-sns-line.svg';
import {REGION} from '../../common/constant';
import useTheme from '../../common/hook/useTheme';
import {IRegion, ITheme} from '../../common/type';
import {IGlobalLoginMethod} from '../type';

interface IProps {
  onClickLoginSns: (loginMethod: IGlobalLoginMethod) => void;
}

export default function SnsAuth({onClickLoginSns}: IProps) {
  const snsAuthList = SNS_AUTH_LIST_REGION_MAP[REGION];
  const {theme} = useTheme();
  return (
    <div className="w-full mb-2 mt-14 flex-center">
      {snsAuthList.map((type, index) => (
        <Fragment key={type}>
          <img
            src={SNS_AUTH_ICON_MAP[theme][type]}
            alt={type}
            key={type}
            className={cn(
              'flex-none h-50 w-50 sm:h-55 sm:w-55',
              index > 0 && 'ml-12'
            )}
            onClick={() => onClickLoginSns(type)}
          />
        </Fragment>
      ))}
    </div>
  );
}

const SNS_AUTH_LIST_REGION_MAP: {[key in IRegion]: IGlobalLoginMethod[]} = {
  kor: [],
  twn: ['GG', 'FB', 'AP', 'LN'],
  tha: ['GG', 'FB', 'AP', 'LN'],
  idn: ['GG', 'FB', 'AP'],
};

const SNS_AUTH_ICON_MAP: {
  [key in ITheme]: {[key in IGlobalLoginMethod]: string};
} = {
  light: {
    GG: ICON_GOOGLE_LIGHT,
    FB: ICON_FACEBOOK,
    AP: ICON_APPLE_LIGHT,
    LN: ICON_LINE,
  },
  dark: {
    GG: ICON_GOOGLE,
    FB: ICON_FACEBOOK,
    AP: ICON_APPLE,
    LN: ICON_LINE,
  },
};
